import { mapSchoolSegment } from '@websrc/DataMappers/mapSchoolSegment'
import { themeVars } from 'leds'
import { match } from 'ts-pattern'

export const getSchoolSegmentColor = (color: ReturnType<typeof mapSchoolSegment>['color']) =>
  match(color)
    .with('Blue', () => themeVars.color.mediumAzur)
    .with('Dark green', () => themeVars.color.green)
    .with('Light green', () => themeVars.color.lime)
    .otherwise(() => undefined)
